import { render, staticRenderFns } from "./BestTeachers.vue?vue&type=template&id=03d49da4&scoped=true&"
import script from "./BestTeachers.vue?vue&type=script&lang=ts&"
export * from "./BestTeachers.vue?vue&type=script&lang=ts&"
import style0 from "./BestTeachers.vue?vue&type=style&index=0&id=03d49da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d49da4",
  null
  
)

export default component.exports